// This file is used to generate the navigation menu for the web app.

const fullMenu = [
  {
    title: "Channels",
    sections: [
      {
        heading: "Channels",
        slug: "/tags/6YlOrw/channels",
        tags: [],
      },
    ],
  },
  {
    title: "Activity & Movement",
    sections: [
      {
        heading: "Dance & Move",
        slug: "/tags/lYVvRY/dance-and-move",
        tags: [
          {
            name: "Call & Repeat",
            description: "",
            slug: "/tags/W2gdQw/call-and-repeat",
          },
          {
            name: "Follow Along",
            description: "",
            slug: "/tags/3Y8PyY/follow-along",
          },
          {
            name: "Freestyle Moves",
            description: "",
            slug: "/tags/z25LWX/freestyle-moves",
          },
          {
            name: "Move, Shake & Boogie!",
            description: "",
            slug: "/tags/b2a8pX/move-shake-and-boogie",
          },
          {
            name: "Pop Favorites",
            description: "",
            slug: "/tags/9XW8y2/pop-favorites",
          },
        ],
      },
      {
        heading: "Workout & Exercise",
        slug: "/tags/72GzXe/workout-exercise",
        tags: [
          {
            name: "Champ Training",
            description: "",
            slug: "/tags/lYOJ8w/champ-training",
          },
          {
            name: "Coordination Skills",
            description: "",
            slug: "/tags/L2nyXW/coordination-skills",
          },
          {
            name: "Lower Body Workout",
            description: "",
            slug: "/tags/PXoMEw/lower-body-workout",
          },
          {
            name: "Run, Jump, Dodge & Duck",
            description: "",
            slug: "/tags/QXBq4Y/run-jump-dodge-and-duck",
          },
          {
            name: "Sports Skills",
            description: "",
            slug: "/tags/WwJ6Ow/sports-skills",
          },
        ],
      },
      {
        heading: "Breathing Exercises",
        slug: "/tags/72Gb5X/breathing-exercises",
        tags: [
          {
            name: "Energy & Intention",
            description: "",
            slug: "/tags/kYzxE2/energy-and-intention",
          },
          {
            name: "Focus & Settle",
            description: "",
            slug: "/tags/Ww4oy2/focus-and-settle",
          },
          {
            name: "Reflect & Forgive",
            description: "",
            slug: "/tags/r2rzr2/reflect-and-forgive",
          },
        ],
      },
    ],
  },
  {
    title: "Curriculum & Learning",
    sections: [
      {
        heading: "Curriculum",
        slug: "/tags/lYVL2g/curriculum",
        tags: [
          {
            name: "Language Arts: English",
            description: "",
            slug: "/tags/eYRnYK/language-arts-english",
          },
          {
            name: "Social Studies",
            description: "",
            slug: "/tags/DYLowW/social-studies",
          },
          {
            name: "STEM: Math",
            description: "",
            slug: "/tags/NXQWwn/stem-math",
          },
          {
            name: "STEM: Science",
            description: "",
            slug: "/tags/EY9ZXb/stem-science",
          },
          {
            name: "Health & Nutrition",
            description: "",
            slug: "/tags/nYMo2g/health-and-nutrition",
          },
        ],
      },
      {
        heading: "Grade Levels",
        slug: "/tags/eYxDYg/grades",
        tags: [
          {
            name: "GoNoodle Junior (Pre-K)",
            description: "",
            slug: "/tags/lYOj8w/gonoodle-junior",
          },
          {
            name: "Kindergarten",
            description: "",
            slug: "/tags/GYpvD2/kindergarten",
          },
          {
            name: "1st Grade",
            description: "",
            slug: "/tags/9Y7l9X/1st-grade",
          },
          {
            name: "2nd Grade",
            description: "",
            slug: "/tags/rwqW5X/2nd-grade",
          },
          {
            name: "3rd Grade",
            description: "",
            slug: "/tags/zXNzWX/3rd-grade",
          },
        ],
      },
      {
        heading: "Emotional Literacy",
        slug: "/tags/QXPDZX/emotional-literacy",
        tags: [
          {
            name: "Courage & Confidence",
            description: "",
            slug: "/tags/lYOvnw/courage%20and%20confidence",
          },
          {
            name: "Community & Classroom Behavior",
            description: "",
            slug: "/tags/zXN9vY/community-and-classroom-behavior",
          },
          {
            name: "Adjust Behavior",
            description: "",
            slug: "/tags/GYpzp2/adjust-behavior",
          },
          {
            name: "Set a Goal",
            description: "",
            slug: "/tags/3Y8RJ2/set-a-goal",
          },
          {
            name: "Friendship & Teamwork",
            description: "",
            slug: "/tags/DXDGbY/friendship-teamwork",
          },
        ],
      },
      {
        heading: "Explore SuperNoodle",
        slug: "/tags/lYOoeY/supernoodle",
        tags: [
          {
            name: "Connection",
            description: "",
            slug: "/tags/QXPBQw/connection",
          },
          {
            name: "Choice",
            description: "",
            slug: "/tags/Zwmm1w/choice",
          },
          {
            name: "Coping Skills",
            description: "",
            slug: "/tags/0YZDe2/coping-skills",
          },
          {
            name: "Creativity",
            description: "",
            slug: "/tags/PY1nRX/creativity",
          },
          {
            name: "Compassion",
            description: "",
            slug: "/tags/L2nA9X/compassion",
          },
        ],
      },
    ],
  },
  {
    title: "Holidays & Routines",
    sections: [
      {
        heading: "Holidays",
        slug: "/tags/lYOA2a/holidays-and-events",
        tags: [
          {
            name: "Summertime",
            description: "",
            slug: "/tags/72GmzY/summertime",
          },
          {
            name: "National Great Outdoors Month",
            description: "",
            slug: "/tags/NXQ0WY/the-great-outdoors",
          },
          {
            name: "National Best Friends Day",
            description: "",
            slug: "/tags/DXDGbY/friendship-teamwork",
          },
          {
            name: "Birthdays",
            description: "",
            slug: "/tags/eXdM23/birthdays",
          },
        ],
      },
      {
        heading: "Routines",
        slug: "/tags/r26b2L/routines",
        tags: [
          {
            name: "Class Routines",
            description: "",
            slug: "/tags/xX0ZwZ/class-routines",
          },
          {
            name: "Test Time Energy",
            description: "",
            slug: "/tags/aYyW26/test-time-energy",
          },
          {
            name: "Test Time Focus",
            description: "",
            slug: "/tags/LYE0rw/test-time-focus",
          },
          {
            name: "Meal Time",
            description: "",
            slug: "/tags/rwq5wx/meal-time",
          },
          {
            name: "School's Out",
            description: "",
            slug: "/tags/zXNW2M/schools-out",
          },
        ],
      },
    ],
  },
];

const compactMenu = [
  {
    name: "Explore SuperNoodle",
    slug: "/tags/lYOoeY/supernoodle",
  },
  {
    name: "Search",
    slug: "/search",
  },
  {
    name: "Channels",
    slug: "/tags/6YlOrw/channels",
  },
];

export { fullMenu, compactMenu };
